import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { ExternalLink } from './ExternalLink';

interface GetInspiredProps {
  variant: 'footer' | 'header' | 'subitem';
}

export const GetInspired = ({ variant }: GetInspiredProps) => (
  <ExternalLink variant={variant} href="https://discover.fiverr.com/" category={'Get Inspired'}>
    <I18n k="affiliates_signup_perseus.get_inspired" />
  </ExternalLink>
);
